module.exports = __webpack_public_path__ + "img/GT8.52f4ab11.png";